import { BaseShortcut } from '@shared/directives/shortcuts/base-shortcut';
import { Directive, Output, EventEmitter } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

@Directive({
  selector: 'undo-redo-directive',
  outputs: [ 'undoRequested', 'redoRequested']
})
export class UndoRedoShortcutDirective extends BaseShortcut {
  @Output() undoRequested = new EventEmitter<any>();
  @Output() redoRequested = new EventEmitter<any>();

  constructor(private _dialog: MatDialog) {
    super();
  }

  onKeyPress($event: KeyboardEvent): void {
    if (this._dialog.openDialogs && this._dialog.openDialogs.length > 0) {
      return;
    }

    if (($event.ctrlKey || $event.metaKey) && $event.key === 'z') {
      this.undoRequested.emit();
    }

    if (($event.ctrlKey || $event.metaKey) && $event.key === 'y') {
      this.redoRequested.emit();
    }
  }

  filterEvent(event: any): void {
    if (this._dialog.openDialogs.length > 0) {
      return;
    }
    // On some browser, we have undo-redo already natively handled on some field like text area. We are preventing the default behavior.
    if ((event.ctrlKey || event.metaKey) && ( event.key === 'z' || event.key === 'y')) {
      event.preventDefault();
    }
  }
}
